/**
 * English translation — default language
 */
const en = {
  // ── App shell ──
  app: {
    name: 'Boox Platform',
    logo: 'B',
  },
  tabs: {
    closeAll: 'Close all tabs',
    all: 'All',
  },

  // ── Login ──
  login: {
    title: 'Boox Platform',
    subtitle: 'Sign in to continue',
    email: 'Email',
    loginName: 'Login Name',
    password: 'Password',
    submit: 'Sign In',
    submitting: 'Signing in…',
    failed: 'Login failed',
    heroTitle: 'Intelligent Enterprise Operating System',
    heroDesc: 'Automate operations, track bookings, and manage your entire operation workflow in one place.',
    feature1: 'Real-time Tracking',
    feature2: 'Smart Automation',
    feature3: 'Multi-tenant Support',
    welcomeBack: 'Welcome back',
    forgotPassword: 'Forgot password?',
    securityNote: 'Your connection is encrypted and secure.',
    back: 'Back',
    selectTenant: 'Select workspace',
    brandingLoading: 'Tenant branding is still loading. Please try again in a moment.',
    secureAccessFor: 'Secure access for {{company}}',
    workspaceOnHost: '{{portal}} on {{host}}',
    tenantWorkspace: 'Tenant Workspace',
    shortAccountHint: 'Short account is supported here, for example {{hint}}',
    dedicatedLogin: 'This login is dedicated to {{company}}.',
    unauthorizedTenant: 'You are not authorized to access this application.',
    noTenantAccess: 'Your account does not have access to any tenant.',
    invalidCredentials: 'Invalid username or password.',
    bridgeFailed: 'Failed to continue login',
  },

  // ── Dashboard ──
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome back, {{name}}',
    goodMorning: 'Good morning',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    fields: 'fields',
    children: 'children',
    relations: 'relations',
  },

  // ── Per-category workspace pages ──
  workspace: {
    overview:        'Overview',
    subtitle:        '{{count}} entities',
    quickLinks:      'Quick Links',
    noEntities:      'No entities in this workspace',
    noEntitiesDesc:  'Configure entities for this category in the admin panel.',
    notFound:        'Workspace not found',
    notFoundDesc:    'This workspace is not configured or you don\'t have access.',
  },

  // ── Sidebar category labels ──
  category: {
    // ── Core ──
    home:         'Home',
    builder:      'Business Builder',
    inbox:        'Inbox',
    business:     'Business',
    // ── Verticals ──
    transport:    'Transport Hero V1',
    fleet:        'Fleet',
    freight:      'Freight Pilot',
    warehouse:    'Warehouse Flow',
    haulage:      'Haulage Management V1',
    'supply-chain': 'Supply Chain Navigator',
    service:      'Service Management',
    sas:          'Maritime Desk',
    depot:        'Depot Control',
    soc:          'SOC',
    // ── Support ──
    finance:      'Finance',
    audit:        'Audit & Compliance',
    workforce:    'Workforce',
    // ── Admin (bottom-pinned) ──
    settings:     'Settings',
    platform:     'Platform',
    // ── Legacy (kept for backward compat with old DB configs) ──
    tms:          'Transport Hero V1',
    fms:          'FMS',
    wms:          'WMS',
    accounting:   'Accounting',
    ai:           'AI',
    'ai-command': 'AI Command',
    trucking:     'Trucking',
    accounts:     'Accounts',
    parties:      'Parties',
    messaging:    'Messaging',
    agent:        'Agent',
    config:       'Config',
    master:       'Master Data',
    transaction:  'Operations',
    event:        'Events',
    attachment:   'Attachments',
    communication:'Communication',
    pro2:         'CMS PRO2',
    // ── Network ──
    network:      'Boox Network',
    // ── CC（指挥中心）分类 ──
    tenants:      'Tenant Management',
    'ai-center':  'AI Center',
    'cc-home':      'CC Home',
    'cc-tenants':   'Tenant Ops',
    'cc-brain':     'AI & Brain',
    'cc-builder':   'Builder',
    'cc-observe':   'Observability',
    'cc-analytics': 'Analytics',
    'cc-command': 'Command',
    'cc-revenue': 'Revenue Ops',
    'cc-delivery': 'Delivery Ops',
    'cc-ceo': 'CEO',
    'cc-tenant-admin': 'Tenant Admin',
    'cc-systems': 'Platform Systems',
  },

  // ── Sidebar group labels ──
  group: {
    // ── Home groups ──
    Dashboards:       'Dashboards',
    'Quick Access':   'Quick Access',
    // ── Inbox groups ──
    Messages:         'Messages',
    Tasks:            'Tasks',
    // ── Business groups ──
    Sales:            'Sales',
    Purchase:         'Purchase',
    // ── Transport groups ──
    Operations:       'Operations',
    // ── Freight groups ──
    Oversea:          'Oversea',
    // ── Warehouse groups ── (uses Operations, Setup, Reports)
    // ── Finance groups ──
    AR:               'Accounts Receivable',
    AP:               'Accounts Payable',
    GL:               'General Ledger',
    // ── Workforce groups ──
    People:           'People',
    Branches:         'Branches',
    Access:           'Access',
    // ── Settings groups ──
    Tenant:           'Tenant',
    System:           'System',
    // ── Platform groups ──
    'AI Admin':       'AI Admin',
    DevOps:           'DevOps',
    // ── CC (Command Control) groups ──
    Tenants:          'Tenants',
    Channels:         'Channels',
    Security:         'Security',
    Rules:            'Rules',
    'AI Config':      'AI Config',
    Brain:            'Brain',
    Logs:             'Logs',
    Dev:              'Dev',
    Infra:            'Infrastructure',
    'Platform Intelligence': 'Platform Intelligence',
    overview:         'Overview',
    runtime:          'Runtime',
    tools:            'Tools',
    intake:           'Intake',
    qualification:    'Qualification',
    governance:       'Governance',
    delivery:         'Delivery',
    readiness:        'Readiness',
    executive:        'Executive',
    configuration:    'Configuration',
    build:            'Build',
    'ai-runtime':     'AI Runtime',
    systems:          'Systems',
    monitoring:       'Monitoring',
    // ── Shared groups ──
    Setup:            'Setup',
    Reports:          'Reports',
    'Master Data':    'Master Data',
    Config:           'Config',
    Monitor:          'Monitor',
    // ── Legacy group keys ──
    'Container Trucking': 'Container Trucking',
    'Local Transport':    'Local Transport',
    Sea:              'Sea',
    Air:              'Air',
    'Local Handling': 'Local Handling',
    Customers:        'Customers',
    'Business Parties': 'Business Parties',
    Employees:        'Employees',
    AI:               'AI',
    Driver:           'Driver',
    Workflow:         'Workflow',
    work:             'Work',
    setup:            'Setup',
    transactions:     'Transactions',
    inventory:        'Inventory',
    reports:          'Reports',
    tax:              'Tax',
    customers:        'Customers',
    partners:         'Partners',
    team:             'Team',
    inbox:            'Inbox',
    email:            'Email',
    channels:         'Channels',
    pipeline:         'Pipeline',
    tasks:            'Tasks',
    files:            'Files',
    audit:            'Audit',
    ui:               'UI Templates',
    system:           'System',
    people:           'People',
    jobs:         'Jobs',
    shipping:     'Shipping',
    finance:      'Finance',
    warehouse:    'Warehouse',
    messaging:    'Messaging',
    'inventory-events': 'Inventory Events',
    // ── Module nav group labels (lowercase, used by MODULE_NAV_ITEMS) ──
    dashboard:        'Dashboard',
    orders:           'Orders',
    operations:       'Operations',
    import:           'Import',
    export:           'Export',
    master:           'Master',
    Import:           'Import',
    Export:           'Export',
    Master:           'Master',
    overall:          'Overall',
    operating:        'Operating',
    category:         'Category',
    planning:         'Planning',
    banking:          'Banking',
    admin:            'Admin',
    'self-service':   'Self-Service',
    config:           'Config',
    tenants:          'Tenants',
    policies:         'Policies',
    agents:           'Agents',
    knowledge:        'Knowledge',
    schema:           'Schema',
    templates:        'Templates',
    automation:       'Automation',
    devtools:         'DevTools',
    integration:      'Integration',
    deployment:       'Deployment',
    communication:    'Communication',
    breakdown:        'Breakdown',
    realtime:         'Realtime',
    trends:           'Trends',
    // ── Finance module groups (new) ──
    processes:        'Processes',
    management:       'Management Reports',
    einvoicing:       'E-Invoicing',
    compliance:       'Compliance',
    // ── Network groups ──
    collaboration:    'Collaboration',
    // ── Other new groups ──
    review:           'Review',
    crm:              'RM',
    messages:         'Messages',
    schedule:         'Schedule',
    docs:             'Documents',
    // ── Module sidebar groups (used by MODULE_NAV_ITEMS) ──
    ai:               'AI',
    'boox-network':   'Boox Network',
    circles:          'Circles',
    contacts:         'Contacts',
    fulfillment:      'Fulfillment',
    personal:         'Personal',
    procurement:      'Procurement',
    requests:         'Requests',
    resources:        'Resources',
    safety:           'Safety',
    sales:            'Sales',
    sourcing:         'Sourcing',
    tenant:           'Tenant',
    views:            'Views',
    collections:      'Collections',
    control:          'Control',
    core:             'Core',
    devops:           'DevOps',
    execution:        'Execution',
    fleet:            'Fleet',
    'master-data':    'Master Data',
    ops:              'Operations',
    platform:         'Platform',
    workshop:         'Workshop',
    workspace:        'Workspace',
  },

  // ── Entity list ──
  list: {
    totalRecords: '{{count}} records',
    newBtn: 'New',
    cancel: 'Cancel',
    createTitle: 'New {{label}}',
    createSuccess: '{{label}} created',
    search: 'Search {{label}}…',
    allStatus: 'All statuses',
    loading: 'Loading…',
    noData: 'No data',
    page: 'Page {{current}} / {{total}}',
    loadFailed: 'Failed to load data',
    notFound: 'Entity not found',
  },

  // ── Entity detail ──
  detail: {
    loadFailed: 'Failed to load details',
    notFound: 'Record not found',
    confirmDeleteTitle: 'Confirm Delete',
    confirmDeleteDesc: 'Are you sure you want to delete this {{label}} record? This action cannot be undone.',
    delete: 'Delete',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Delete failed',
    actionSuccess: '{{action}} executed',
    actionFailed: '{{action}} failed',
    cancelEdit: 'Cancel Edit',
    edit: 'Edit',
    editTitle: 'Edit {{label}}',
    tabHuman: 'Full View',
    tabBasic: 'Basic',
    tabJson: 'JSON',
  },

  // ── Entity edit form ──
  form: {
    required: '{{field}} is required',
    minValue: 'Minimum value is {{min}}',
    maxValue: 'Maximum value is {{max}}',
    invalidFormat: 'Invalid format',
    selectPlaceholder: 'Select…',
    boolTrue: 'Yes',
    boolFalse: 'No',
    saveSuccess: 'Saved',
    createSuccess: 'Created',
    saveFailed: 'Save failed',
    save: 'Save',
    create: 'Create',
    cancel: 'Cancel',
  },

  // ── Human view ──
  humanView: {
    summary: 'Summary',
    relatedData: 'Related Data',
    childEntities: 'Child Entities',
    moreRows: '{{count}} more…',
    boolTrue: 'Yes',
    boolFalse: 'No',
    empty: '—',
  },

  // ── Basic view ──
  basicView: {
    basicInfo: 'Basic Info',
    extendedData: 'Extended Data',
    boolTrue: 'Yes',
    boolFalse: 'No',
    empty: '—',
  },

  // ── View template fallback sections ──
  viewTemplate: {
    basicInfo: 'Basic Info',
    financialInfo: 'Financial Info',
    timeline: 'Timeline',
    otherInfo: 'Other Info',
  },

  // ── Export ──
  export: {
    csv: 'Export CSV',
    success: 'Export complete',
    failed: 'Export failed, please retry',
  },

  // ── Notifications ──
  notification: {
    title: 'Notifications',
    markAllRead: 'Mark all read',
    loading: 'Loading…',
    empty: 'No notifications',
    justNow: 'just now',
    minutesAgo: '{{count}} min ago',
    hoursAgo: '{{count}} hr ago',
    daysAgo: '{{count}} days ago',
  },

  // ── Confirm dialog ──
  confirm: {
    ok: 'Confirm',
    cancel: 'Cancel',
    processing: 'Processing…',
  },

  // ── Error boundary ──
  error: {
    title: 'Something went wrong',
    fallback: 'An unexpected error occurred.',
    tryAgain: 'Try Again',
    goHome: 'Go Home',
  },

  // ── Search / Command Palette ──
  search: {
    placeholder: 'Search entities… ⌘K',
    noResults: 'No matching entities',
    navigate: 'Navigate',
    open: 'Open',
    results: '{{count}} results',
  },

  // ── User dropdown ──
  user: {
    profile: 'Profile',
    settings: 'Settings',
    shortcuts: 'Keyboard Shortcuts',
    signOut: 'Sign Out',
    switchTenant: 'Switch Company',
  },

  // ── Navigation actions ──
  nav: {
    chat: 'Chat',
    home: 'Home',
    teamspace: 'Teamspace',
    ceoDesk: 'CEO Desk',
    booxCommand: 'Boox Command',
    aiChat: 'AI Chat',
    brainMonitor: 'Brain Monitor',
    runtimeDebug: 'Runtime Debug',
    alertCenter: 'Alert Center',
    rolloutDashboard: 'Rollout Dashboard',
    revenueInbox: 'Revenue Inbox',
    messagingIntake: 'Messaging Intake',
    surfaceAccess: 'Surface Access',
    partnerApplications: 'Partner Applications',
    onboardingControl: 'Onboarding Control',
    onboardingRecords: 'Onboarding Records',
    assignmentPolicies: 'Assignment Policies',
    capabilityMatrix: 'Capability Matrix',
    stateConsole: 'State Console',
    eInvoicingOps: 'E-Invoicing Ops',
    strategy: 'Strategy',
    fundraising: 'Fundraising',
    dataRoom: 'Data Room',
    aiCoCeo: 'AI Co-CEO',
    tenants: 'Tenants',
    globalUsers: 'Global Users',
    userRoles: 'User Roles',
    authControl: 'Auth Control',
    capabilities: 'Capabilities',
    policies: 'Policies',
    exceptionPolicies: 'Exception Policies',
    workflowPolicies: 'Workflow Policies',
    whatsAppAdmin: 'WhatsApp',
    builder: 'Builder',
    businessPackages: 'Business Packages',
    platformSystems: 'Platform Systems',
    configCompiler: 'Config Compiler',
    configVersions: 'Config Versions',
    domainConfigs: 'Domain Configs',
    menuConfig: 'Menu Config',
    bridges: 'Bridges',
    dataTransfer: 'Data Transfer',
    deployControl: 'Deploy Control',
    printCenter: 'Print Center',
    platformAnalytics: 'Platform Analytics',
    logExplorer: 'Log Explorer',
    schemaEditor: 'Schema Editor',
    dslDesigner: 'DSL Designer',
    viewTemplates: 'View Templates',
    documentTemplates: 'Document Templates',
    workflows: 'Workflows',
    workflowTemplates: 'Workflow Templates',
    scripts: 'Scripts',
    aiCommandCenter: 'AI Command Center',
    aiTeam: 'AI Team',
    agentLab: 'Agent Lab',
    skills: 'Skills',
    skillConfig: 'Skill Config',
    prompts: 'Prompts',
    trainingData: 'Training Data',
    memory: 'Memory',
    tools: 'Tools',
    aiControlPlane: 'AI Control Plane',
    brainLogs: 'Brain Logs',
    brainSoul: 'Brain Soul',
    brainSchedule: 'Brain Schedule',
    recurringTasks: 'Recurring Tasks',
    taskCenter: 'Task Center',
    executiveNudges: 'Executive Nudges',
    apiCenter: 'API Center',
    accessLog: 'Access Log',
    userPerformance: 'User Performance',
    jobTimeline: 'Job Timeline',
    pro2: {
      importShipment: 'Import Shipment',
      importShipments: 'Import Shipments',
      importContainer: 'Import Container',
      importContainers: 'Import Containers',
      importCargo: 'Import Cargo',
      exportShipment: 'Export Shipment',
      exportShipments: 'Export Shipments',
      exportBooking: 'Export Booking',
      exportBookings: 'Export Bookings',
      exportContainer: 'Export Container',
      exportContainers: 'Export Containers',
      exportCargo: 'Export Cargo',
      invCostNote: 'Invoice / Cost Note',
      invCostNotes: 'Invoice / Cost Notes',
      chargeLine: 'Charge Line',
      chargeLines: 'Charge Lines',
      company: 'Company',
      companies: 'Companies',
    },
    // Home
    Dashboards: 'Dashboards',
    'Team Monitor': 'Team Monitor',
    Shortcuts: 'Shortcuts',
    Recent: 'Recent',
    // Inbox
    'All Messages': 'All Messages',
    Emails: 'Emails',
    WhatsApp: 'WhatsApp',
    'My Tasks': 'My Tasks',
    Approvals: 'Approvals',
    Alerts: 'Alerts',
    // Business
    Orders: 'Orders',
    Quotations: 'Quotations',
    Pipelines: 'Pipelines',
    Goals: 'Goals',
    'Purchase Orders': 'Purchase Orders',
    'Vendor Sourcing': 'Vendor Sourcing',
    Customers: 'Customers',
    Vendors: 'Vendors',
    Contacts: 'Contacts',
    'Sales Reports': 'Sales Reports',
    // Transport
    Jobs: 'Jobs',
    Planner: 'Planner',
    'FCL Planner': 'FCL Planner',
    'LCL Planner': 'LCL Planner',
    Trips: 'Trips',
    'Live Tracking': 'Live Tracking',
    Dispatch: 'Dispatch',
    'Master Data': 'Master Data',
    Drivers: 'Drivers',
    Vehicles: 'Vehicles',
    Routes: 'Routes',
    Billing: 'Billing',
    // Freight
    'Sea Imports': 'Sea Imports',
    'Sea Exports': 'Sea Exports',
    'Air Imports': 'Air Imports',
    'Air Exports': 'Air Exports',
    'Port System': 'Port System',
    CFS: 'CFS',
    Customs: 'Customs',
    Documents: 'Documents',
    Rates: 'Rates',
    Carriers: 'Carriers',
    Vessels: 'Vessels',
    Accounting: 'Accounting',
    'Volume Reports': 'Volume Reports',
    // Warehouse
    Inbound: 'Inbound',
    Inventory: 'Inventory',
    Outbound: 'Outbound',
    'Work Orders': 'Work Orders',
    Warehouses: 'Warehouses',
    Locations: 'Locations',
    'Stock Reports': 'Stock Reports',
    Movements: 'Movements',
    // Finance
    Invoices: 'Invoices',
    Receipts: 'Receipts',
    'AR Aging': 'AR Aging',
    'Vendor Bills': 'Vendor Bills',
    Payments: 'Payments',
    'Journal Entries': 'Journal Entries',
    'Chart of Accounts': 'Chart of Accounts',
    'Bank Account': 'Bank Account',
    'Bank Accounts': 'Bank Accounts',
    Statement: 'Statement',
    'Bank Statements': 'Bank Statements',
    Reconciliation: 'Reconciliation',
    'Charge Code': 'Charge Code',
    'Charge Codes': 'Charge Codes',
    'Tax Jurisdiction': 'Tax Jurisdiction',
    'Tax Jurisdictions': 'Tax Jurisdictions',
    'Tax Codes': 'Tax Codes',
    'Tax Rule': 'Tax Rule',
    'Tax Rules': 'Tax Rules',
    'P&L Reports': 'P&L Reports',
    'Balance Sheets': 'Balance Sheets',
    Shipment: 'Shipment',
    Shipments: 'Shipments',
    Overview: 'Overview',
    Accounts: 'Accounts',
    Bookings: 'Bookings',
    Documentation: 'Documentation',
    Release: 'Release',
    'Local Services': 'Local Services',
    Schedules: 'Schedules',
    'Principal Tasks': 'Principal Tasks',
    'AI Intake': 'AI Intake',
    Yard: 'Yard',
    Moves: 'Moves',
    Maintenance: 'Maintenance',
    Exceptions: 'Exceptions',
    Releases: 'Releases',
    Repairs: 'Repairs',
    Container: 'Container',
    Containers: 'Containers',
    Cargo: 'Cargo',
    Costing: 'Costing',
    Import: 'Import',
    Export: 'Export',
    Transhipment: 'Transhipment',
    'Cross Trade': 'Cross Trade',
    Local: 'Local',
    Consol: 'Consol',
    Air: 'Air',
    'Shipment Report': 'Shipment Report',
    'Billing Report': 'Billing Report',
    'Imp Shipment': 'Imp Shipment',
    'Imp Container': 'Imp Container',
    'Imp Cargo': 'Imp Cargo',
    'Exp Shipment': 'Exp Shipment',
    'Exp Booking': 'Exp Booking',
    'Exp Container': 'Exp Container',
    'Exp Cargo': 'Exp Cargo',
    'Inv / Cost Note': 'Inv / Cost Note',
    'Charge Lines': 'Charge Lines',
    'Quotation / Rates': 'Quotation / Rates',
    'Job Order': 'Job Order',
    'Job Orders': 'Job Orders',
    'By Customer': 'By Customer',
    'By Date': 'By Date',
    'Driver Log': 'Driver Log',
    'Driver Pay': 'Driver Pay',
    // Workforce
    Employees: 'Employees',
    Departments: 'Departments',
    Branches: 'Branches',
    Roles: 'Roles',
    Permissions: 'Permissions',
    // Settings
    'General Settings': 'General Settings',
    'My Profile': 'My Profile',
    'Company Settings': 'Company Settings',
    Team: 'Team',
    // ── CC (Command Control) nav items ──
    Home: 'Home',
    Tenants: 'Tenants',
    'Users & Roles': 'Users & Roles',
    Capabilities: 'Capabilities',
    'Capability Matrix': 'Capability Matrix',
    'WhatsApp Config': 'WhatsApp Config',
    'Menu Config': 'Menu Config',
    'Domain Configs': 'Domain Configs',
    'Auth Control': 'Auth Control',
    'Command Center': 'Command Center',
    'AI Team': 'AI Team',
    Skills: 'Skills',
    'Skill Config': 'Skill Config',
    'Rules & Policies': 'Rules & Policies',
    'Exception Policies': 'Exception Policies',
    'Workflow Policies': 'Workflow Policies',
    Prompts: 'Prompts',
    'Training Data': 'Training Data',
    'Memory Manager': 'Memory Manager',
    'Brain Monitor': 'Brain Monitor',
    'Brain Logs': 'Brain Logs',
    'Brain Soul': 'Brain Soul',
    'Brain Schedule': 'Brain Schedule',
    'Thread Logs': 'Thread Logs',
    'Agent Lab': 'Agent Lab',
    Messaging: 'Messaging',
    'Email Logs': 'Email Logs',
    'Email Accounts': 'Email Accounts',
    'WhatsApp Groups': 'WhatsApp Groups',
    'Platform Admin': 'Platform Admin',
    'Rollout Dashboard': 'Rollout Dashboard',
    'Deploy Control': 'Deploy Control',
    'AI Control Plane': 'AI Control Plane',
    'Bridge Registry': 'Bridge Registry',
    'Tool Registry': 'Tool Registry',
    'Doc Templates': 'Doc Templates',
    'Schema Editor': 'Schema Editor',
    Workflows: 'Workflows',
    'WF Templates': 'Workflow Templates',
    Scripts: 'Scripts',
    'Config Versions': 'Config Versions',
    'Config Compiler': 'Config Compiler',
    'View Templates': 'View Templates',
    'DSL Designer': 'DSL Designer',
    'Print Center': 'Print Center',
    // ── CC additional labels (matching MODULE_NAV_ITEMS labelPlural) ──
    Rollout: 'Rollout',
    'AI Chat': 'AI Chat',
    'Global Users': 'Global Users',
    'User Roles': 'User Roles',
    Policies: 'Policies',
    Schedule: 'Schedule',
    Tools: 'Tools',
    Memory: 'Memory',
    'Email Intake': 'Email Intake',
    'Log Explorer': 'Log Explorer',
    'Job Timeline': 'Job Timeline',
    Bridges: 'Bridges',
    'Email Inbox': 'Email Inbox',
    'Platform KPI': 'Platform KPI',
    'By Company': 'By Company',
    'By Region': 'By Region',
    'By Port Pair': 'By Port Pair',
    'Haulage Live': 'Haulage Live',
    'Freight Volume': 'Freight Volume',
    'WMS Throughput': 'WMS Throughput',
    'Growth & Churn': 'Growth & Churn',
    'AI Efficiency': 'AI Efficiency',
    // ── Driver PWA nav ──
    'My Trips': 'My Trips',
    'My Pay': 'My Pay',
    Driver: 'Driver',
    // ── Module nav items (used by MODULE_NAV_ITEMS in sidebar) ──
    // Home
    Dashboard: 'Dashboard',
    Today: 'Today',
    Inbox: 'Inbox',
    Email: 'Email',
    'AI Review': 'AI Review',
    Directory: 'Directory',
    Connections: 'Connections',
    Messages: 'Messages',
    Channels: 'Channels',
    // Business (OMS)
    Pipeline: 'Pipeline',
    'Business Party': 'Business Party',
    'Business Parties': 'Business Parties',
    Customer: 'Customer',
    Circles: 'Circles',
    Group: 'Group',
    Groups: 'Groups',
    RFQ: 'RFQ',
    // Transport (TMS)
    'Event Log': 'Event Log',
    // Haulage (HMS)
    'Control Room': 'Control Room',
    'AI CS Manager': 'AI CS Manager',
    'Staff Performance': 'Staff Performance',
    'TR128 Audit': 'TR128 Audit',
    'CO2e Report': 'CO2e Report',
    // Freight (FMS)
    'Sea Schedule': 'Sea Schedule',
    // PRO2 (mapped via labelKey, kept here for completeness)
    'Import Shipment': 'Import Shipment',
    'Import Shipments': 'Import Shipments',
    'Import Container': 'Import Container',
    'Import Containers': 'Import Containers',
    'Import Cargo': 'Import Cargo',
    'Export Shipment': 'Export Shipment',
    'Export Shipments': 'Export Shipments',
    'Export Booking': 'Export Booking',
    'Export Bookings': 'Export Bookings',
    'Export Container': 'Export Container',
    'Export Containers': 'Export Containers',
    'Export Cargo': 'Export Cargo',
    'Invoice / Cost Note': 'Invoice / Cost Note',
    'Invoice / Cost Notes': 'Invoice / Cost Notes',
    'Charge Line': 'Charge Line',
    Company: 'Company',
    Companies: 'Companies',
    // Supply Chain (SCM)
    'Sales Order': 'Sales Order',
    'Sales Orders': 'Sales Orders',
    Quotation: 'Quotation',
    Salesperson: 'Salesperson',
    Salespersons: 'Salespersons',
    'Purchase Order': 'Purchase Order',
    Supplier: 'Supplier',
    Suppliers: 'Suppliers',
    Product: 'Product',
    Products: 'Products',
    'Stock Movement': 'Stock Movement',
    'Stock Movements': 'Stock Movements',
    Fulfillment: 'Fulfillment',
    'Shipment Tracking': 'Shipment Tracking',
    Reports: 'Reports',
    // Service (SVC)
    'Service Order': 'Service Order',
    'Service Orders': 'Service Orders',
    Equipment: 'Equipment',
    Crew: 'Crew',
    Crews: 'Crews',
    Sites: 'Sites',
    // Warehouse (WMS)
    Tasks: 'Tasks',
    'QC / Inspection': 'QC / Inspection',
    'Warehouse Tasks': 'Warehouse Tasks',
    'Arrival Dock': 'Arrival Dock',
    PO: 'PO',
    'Material Request': 'Material Request',
    'Material Requests': 'Material Requests',
    'Material Return': 'Material Return',
    'Inventory Transfer': 'Inventory Transfer',
    'Inventory Return': 'Inventory Return',
    'Shared Documents': 'Shared Documents',
    '3PL Management': '3PL Management',
    Supervisor: 'Supervisor',
    'Executive KPI': 'Executive KPI',
    'CS Workbench': 'CS Workbench',
    // Finance
    'Accounts Receivable': 'Accounts Receivable',
    'Accounts Payable': 'Accounts Payable',
    'Journal Entry': 'Journal Entry',
    'AR Collection': 'AR Collection',
    'Payment Run': 'Payment Run',
    'Payment Runs': 'Payment Runs',
    'AP Aging': 'AP Aging',
    'Statement of A/c': 'Statement of A/c',
    'Statements of A/c': 'Statements of A/c',
    'Tax Report': 'Tax Report',
    'Tax Reports': 'Tax Reports',
    'General Ledger': 'General Ledger',
    'Trial Balance': 'Trial Balance',
    'Profit & Loss': 'Profit & Loss',
    'Balance Sheet': 'Balance Sheet',
    'Cash Flow': 'Cash Flow',
    'Management A/c': 'Management A/c',
    'Management Accounts': 'Management Accounts',
    'Audit Report': 'Audit Report',
    'Audit Reports': 'Audit Reports',
    'Process Audit': 'Process Audit',
    'Process Audits': 'Process Audits',
    Consolidation: 'Consolidation',
    'E-Invoicing': 'E-Invoicing',
    'Audit Overview': 'Audit Overview',
    Settlement: 'Settlement',
    Disputes: 'Disputes',
    'Bill Audit': 'Bill Audit',
    'Bill Audits': 'Bill Audits',
    'Accounting Periods': 'Accounting Periods',
    'Tax Config': 'Tax Config',
    'Exchange Rates': 'Exchange Rates',
    'Legal Entities': 'Legal Entities',
    // Workforce (HRM)
    Attendance: 'Attendance',
    Payroll: 'Payroll',
    'Leave Types': 'Leave Types',
    'Leave Mgmt': 'Leave Mgmt',
    Holidays: 'Holidays',
    'Holiday Calendar': 'Holiday Calendar',
    Loans: 'Loans',
    'Claims Approval': 'Claims Approval',
    Safety: 'Safety',
    Incidents: 'Incidents',
    Checklists: 'Checklists',
    Signoffs: 'Signoffs',
    Training: 'Training',
    Briefings: 'Briefings',
    'Safety Briefings': 'Safety Briefings',
    'Work Summaries': 'Work Summaries',
    'My Leave': 'My Leave',
    'My Attendance': 'My Attendance',
    'My Payslip': 'My Payslip',
    'My Loans': 'My Loans',
    'My Claims': 'My Claims',
    // Settings
    General: 'General',
    Profile: 'Profile',
    'PWA Settings': 'PWA Settings',
    'PWA Install Policies': 'PWA Install Policies',
    'Surface Access': 'Surface Access',
    'Team Members': 'Team Members',
    Templates: 'Templates',
    'Document Templates': 'Document Templates',
    'Knowledge Base': 'Knowledge Base',
    Builder: 'Builder',
    'Builder Studio': 'Builder Studio',
    'Business Packages': 'Business Packages',
    'Package Exchange': 'Package Exchange',
    'AI Co-CEO': 'AI Co-CEO',
    'AI Command Center': 'AI Command Center',
    'API Center': 'API Center',
    'AR/AP Netting': 'AR/AP Netting',
    'Access Log': 'Access Log',
    Activities: 'Activities',
    'Admin Setup': 'Admin Setup',
    'Agency Accounts': 'Agency Accounts',
    'Alert Center': 'Alert Center',
    Alliance: 'Alliance',
    Alliances: 'Alliances',
    Amber: 'Amber',
    Appraisal: 'Appraisal',
    'Assignment Policies': 'Assignment Policies',
    'Bahasa Indonesia': 'Bahasa Indonesia',
    'Bahasa Melayu': 'Bahasa Melayu',
    Blue: 'Blue',
    'Boox Command': 'Boox Command',
    'CEO Desk': 'CEO Desk',
    'RM Intelligence Rules': 'RM Intelligence Rules',
    Commercial: 'Commercial',
    Contracts: 'Contracts',
    'Daily Schedule': 'Daily Schedule',
    'Data Room': 'Data Room',
    'Data Transfer': 'Data Transfer',
    'Design Copilot': 'Design Copilot',
    'E-Invoicing Ops': 'E-Invoicing Ops',
    English: 'English',
    'Executive Nudges': 'Executive Nudges',
    'Feeder Bookings': 'Agency Jobs',
    Finance: 'Finance',
    'Financial Setup': 'Financial Setup',
    'Fixed Assets': 'Fixed Assets',
    Fundraising: 'Fundraising',
    Gate: 'Gate',
    Green: 'Green',
    Incentives: 'Incentives',
    Indigo: 'Indigo',
    Inspection: 'Inspection',
    'Issue Orders': 'Issue Orders',
    'Kudos Wall': 'Kudos Wall',
    'LLM Intake Test': 'LLM Intake Test',
    'MCP Management': 'MCP Management',
    'Messaging Intake': 'Messaging Intake',
    'Onboarding Assignment Policies': 'Onboarding Assignment Policies',
    'Onboarding Control': 'Onboarding Control',
    'Onboarding Records': 'Onboarding Records',
    Part: 'Part',
    Parts: 'Parts',
    'Partner Applications': 'Partner Applications',
    'Payroll & Compliance': 'Payroll & Compliance',
    'Performance Appraisals': 'Performance Appraisals',
    Pink: 'Pink',
    'Platform Analytics': 'Platform Analytics',
    'Platform Systems': 'Platform Systems',
    'Port Call Docs': 'Port Call Docs',
    Pricing: 'Pricing',
    Profitability: 'Profitability',
    Purple: 'Purple',
    'REST API': 'REST API',
    'Re-use Leads': 'Re-use Leads',
    Recovery: 'Recovery',
    'Recurring Tasks': 'Recurring Tasks',
    Revenue: 'Revenue',
    'Revenue Inbox': 'Revenue Inbox',
    Rose: 'Rose',
    'Runtime Debug': 'Runtime Debug',
    'Safety Hub': 'Safety Hub',
    'Schedule Board': 'Schedule Board',
    Settings: 'Settings',
    Setup: 'Setup',
    'Shift Swap Requests': 'Shift Swap Requests',
    'Shift Swaps': 'Shift Swaps',
    'Site Ops': 'Site Ops',
    'State Console': 'State Console',
    'Stock Ledger': 'Stock Ledger',
    Strategy: 'Strategy',
    'Tally Control': 'Tally Control',
    Tariff: 'Tariff',
    'Task Center': 'Task Center',
    'Tax Configuration': 'Tax Configuration',
    Teal: 'Teal',
    Teamspace: 'Teamspace',
    'Tiếng Việt': 'Tiếng Việt',
    Tyre: 'Tyre',
    Tyres: 'Tyres',
    'User Performance': 'User Performance',
    Vehicle: 'Vehicle',
    WMS: 'WMS',
    'WMS Setup': 'WMS Setup',
    'Workflow Templates': 'Workflow Templates',
    'ไทย': 'ไทย',
    '中文': '中文',
    '日本語': '日本語',
    '繁體中文': '繁體中文',
  },

  networkPage: {
    common: {
      close: 'Close',
      cancel: 'Cancel',
      refresh: 'Refresh',
      unknown: 'Unknown',
    },
    circleTypes: {
      ownership: 'Ownership Group',
      agent_network: 'Agent Network',
      vendor_panel: 'Vendor Panel',
      peer_circle: 'Peer Circle',
      consortium: 'Consortium',
    },
    groupEntityTypes: {
      hq: 'HQ',
      subsidiary: 'Subsidiary',
      branch: 'Branch',
      associate: 'Associate',
      default: 'Subsidiary',
    },
    circles: {
      memberCount: '{{count}} members',
      owner: 'Owner',
      admin: 'Admin',
      detailLoadFailed: 'Failed to load circle details',
      nameRequired: 'Please enter a circle name',
      createdSuccess: 'Circle created',
      createFailed: 'Failed to create circle',
      listLoadFailed: 'Failed to load circles',
      createTitle: 'Create New Circle',
      nameLabel: 'Circle Name *',
      namePlaceholder: 'Example: CMS Agent Network',
      typeLabel: 'Circle Type *',
      descLabel: 'Description (optional)',
      descPlaceholder: 'Briefly describe what this circle is for',
      createSubmitting: 'Creating...',
      createAction: 'Create Circle',
      title: 'Trade Networks & Circles',
      subtitle: 'Separate exclusive ownership groups from overlapping trade networks and collaboration circles',
      ownershipNoteBadge: 'Ownership Group',
      ownershipNoteDesc: 'Each company belongs to only one ownership group. That relationship is managed separately.',
      openGroupPage: 'Open Group Page',
      emptyTitle: 'You have not joined any circles yet',
      emptyDesc: 'Create your first circle to start collaborating with partners',
      typeCount: '{{count}} items',
      membersTitle: 'Members ({{count}})',
      tradeNetworksTitle: 'Trade Networks',
      tradeNetworksDesc: 'Overlapping agency networks, co-loader alliances, and formal business networks.',
      tradeNetworksEmptyDesc: 'No trade networks yet. Create one for overlapping business relationships such as CMS Group Network, Portever Group Network, or E-Freight Global Network.',
      circlesSectionTitle: 'Circles',
      circlesSectionDesc: 'Smaller operational circles such as trucker, transporter, co-loader, or friend-based collaboration groups.',
      circlesSectionEmptyDesc: 'No circles yet. Create a local collaboration circle for vendors, transporters, or peer partners.',
    },
    groups: {
      current: 'Current',
      switch: 'Switch',
      loadFailed: 'Failed to load group information',
      switchSuccess: 'Workspace switched. Refreshing...',
      switchFailed: 'Switch failed. Please try again.',
      title: 'Ownership Group',
      subtitle: 'Each company belongs to one group only. View member companies, HQ, office base, and switch workspace within the group.',
      emptyTitle: 'Your account has not joined any group yet',
      emptyDesc: 'Contact the platform administrator to add your company into a group',
      summary: 'Ownership Group · {{count}} member companies',
      roleFallback: 'Member',
      exclusiveBadge: 'Exclusive',
      hqLabel: 'HQ',
      hqCompany: 'HQ Company',
      memberCompanies: 'Member Companies',
      coverage: 'Country Coverage',
      companyMembersTitle: 'Group Companies',
      adminMembersTitle: 'Group Admins & Members ({{count}})',
      officeBaseValue: '{{country}} · {{city}}',
      timezoneValue: 'TZ {{timezone}}',
      currencyValue: 'Base {{currency}}',
      noOfficeBase: 'Office base pending',
    },
    rfq: {
      pageTitle: 'RFQ Workspace',
      pageSubtitle: 'Create RFQs or review quotation requests you received',
      creator: 'Created by me',
      detailLoadFailed: 'Failed to load RFQ details',
      publishSuccess: 'RFQ published. Waiting for quotations.',
      publishFailed: 'Failed to publish RFQ',
      quoteAmountRequired: 'Please enter a quote amount',
      quoteSubmitSuccess: 'Quotation submitted',
      quoteSubmitFailed: 'Failed to submit quotation',
      titleRequired: 'Please enter an RFQ title',
      draftCreated: 'RFQ draft created',
      createFailed: 'Failed to create RFQ',
      listLoadFailed: 'Failed to load RFQ list',
      typeSpot: 'Spot RFQ',
      typeContract: 'Contract RFQ',
      typeRecurring: 'Recurring RFQ',
      modeSealed: 'Sealed Bid',
      modeOpen: 'Open Bid',
      modeMixed: 'Mixed Mode',
      tabInfo: 'Basic Info',
      tabQuotes: 'Quotes',
      tabSubmit: 'Submit Quote',
      fieldType: 'RFQ Type',
      fieldCurrency: 'Currency',
      fieldDeadline: 'Deadline',
      fieldCreatedAt: 'Created At',
      cargoSummary: 'Cargo Summary',
      publishSubmitting: 'Publishing...',
      publishAction: 'Publish RFQ and start collecting quotations',
      inviteesTitle: 'Invitees ({{count}})',
      emptyQuotes: 'No quotations yet',
      awarded: 'Awarded',
      submittedAt: 'Submitted at {{date}}',
      quoteAmountLabel: 'Quote Amount ({{currency}}) *',
      quoteNotesLabel: 'Notes (optional)',
      quoteNotesPlaceholder: 'Terms, assumptions, or remarks',
      submitSubmitting: 'Submitting...',
      submitAction: 'Submit Quote',
      createTitle: 'Start New RFQ',
      formTitleLabel: 'RFQ Title *',
      formTitlePlaceholder: 'Example: FCL Haulage Q2 2026 - TANJONG PAGAR',
      formTypeLabel: 'RFQ Type',
      formModeLabel: 'Quotation Mode',
      formCircleLabel: 'Related Circle (optional)',
      formCirclePlaceholder: 'No restriction, open to the entire network',
      formCircleAny: 'No restriction, open to the entire network',
      formDeadlineLabel: 'Quotation Deadline',
      formDescriptionLabel: 'Background Description (optional)',
      formDescriptionPlaceholder: 'Cargo details, service requirements, or other notes',
      createSubmitting: 'Creating...',
      createAction: 'Create Draft',
      tabMine: 'Created by Me',
      tabReceived: 'Received',
      emptyMineTitle: 'No RFQ created yet',
      emptyReceivedTitle: 'No quotation requests received',
      emptyMineDesc: 'Start an RFQ to collect quotations from suppliers',
      startAction: 'Start RFQ',
      statuses: {
        draft: 'Draft',
        published: 'Published',
        quoting: 'Quoting',
        evaluating: 'Evaluating',
        awarded: 'Awarded',
        completed: 'Completed',
        cancelled: 'Cancelled',
        expired: 'Expired',
      },
    },
  },

  crmAccount360: {
    health: {
      attention: 'Attention',
      active: 'Active',
      steady: 'Steady',
    },
    title: 'RM Account 360',
    description: 'Commercial snapshot across contacts, deals, follow-ups, quotations, and jobs.',
    askBoox: 'Ask Boox',
    loading: 'Loading RM account snapshot...',
    loadFailed: 'Failed to load RM account 360',
    promptReviewCustomer: 'Review customer {{name}}. Summarize pipeline, overdue follow-ups, latest quotations, and next best commercial action.',
    unnamedContact: 'Unnamed contact',
    primary: 'Primary',
    decisionMaker: 'Decision maker',
    roleNotSet: 'Role not set',
    noContactChannel: 'No contact channel',
    preferred: 'Preferred: {{channel}}',
    keyContacts: 'Key Contacts',
    noContacts: 'No RM contacts yet.',
    pipelineFollowUp: 'Pipeline & Follow-up',
    noOpenActivity: 'No open RM activity for this account yet.',
    expectedClose: 'Expected close {{date}}',
    due: 'Due {{date}}',
    quotesJobs: 'Quotes & Jobs',
    noQuotesJobs: 'No quotations or jobs linked yet.',
    draft: 'draft',
    validUntil: 'Valid until {{date}}',
    jobTypeFallback: 'Job',
    eta: 'ETA {{date}}',
    cards: {
      openDeals: 'Open Deals',
      weighted: 'Weighted {{value}}',
      pipelineValue: 'Pipeline Value',
      staleDeals: 'Stale deals {{count}}',
      nextFollowUp: 'Next Follow-up',
      overdue: 'Overdue {{count}}',
      openQuotesJobs: 'Open Quotes / Jobs',
      lastTouch: 'Last touch {{date}}',
    },
    actionsTitle: 'AI Next Best Actions',
    actionsDescription: 'Account-specific commercial recommendations synthesized from follow-ups, deal freshness, quotations, and active jobs.',
    actionsEmpty: 'AI does not see an urgent next commercial action for this account yet.',
    recommendations: {
      loading: 'Loading AI priorities...',
      due: 'Due {{date}}',
      score: 'Score {{score}}',
      openAccount360: 'Open Account 360',
      priority: {
        critical: 'Critical',
        high: 'High',
        medium: 'Medium',
        low: 'Low',
      },
      summary: {
        critical: '{{count}} critical',
        high: '{{count}} high',
        medium: '{{count}} medium',
      },
    },
  },

  operationalIntelligence: {
    workspaceNotFound: 'Workspace not found',
    dataRecords: {
      title: 'Operational Registers',
      description: 'Maintain service, incident, warranty, inventory, safety, fleet, and signal registers as editable working tables.',
      loadFailed: 'Failed to load registers',
      importFailed: 'Failed to import register',
      metrics: {
        datasets: 'Registers',
        records: 'Rows',
        uploadMode: 'Upload Mode',
      },
      uploadModes: {
        replace: 'Replace register',
        append: 'Append rows',
      },
      actions: {
        quickCapture: 'Quick Capture',
        documents: 'Documents & Evidence',
        refresh: 'Refresh Data',
      },
      guidance: {
        title: 'Register guidance',
        description: 'Guidance is hidden by default to keep the workspace clean.',
      },
      datasetCard: {
        records: '{{count}} records',
        fields: '{{count}} fields',
        sourceEvidence: 'Source evidence: {{date}}',
        structure: 'Register Fields',
        latestSourceEvidence: 'Latest source evidence',
        storedAt: 'Stored in the shared OPI document workspace on {{date}}',
        openSourceFile: 'Open Source File',
        openLiveRecords: 'Open Full Register',
        addRow: 'Add Row',
        importing: 'Importing...',
        uploadCsv: 'Upload CSV',
      },
    },
    documents: {
      title: 'Documents & Evidence',
      description: 'Upload notes, photos, complaint files, warranty evidence, and source spreadsheets into the shared Operational Intelligence document workspace.',
      workspaceTitle: 'Operational Intelligence document workspace',
      workspaceDescription: 'This page keeps uploaded evidence live and reusable across cases, signals, register rows, and imports.',
      backToSourceData: 'Back To Registers',
      uploadEnabled: 'Upload enabled',
      summary: {
        aiReady: 'AI Ready',
        aiReadyDescription: 'visible documents with AI summary or interpreted purpose',
        draftLinked: 'Draft Linked',
        draftLinkedDescription: 'visible documents that already created or linked a live draft',
        linkedRecords: 'Linked Records',
        linkedRecordsDescription: 'cross-links on the current file list into incidents, signals, cases, and evidence chains',
        pendingReview: 'Pending Review',
        pendingReviewDescription: 'visible documents still pending completion or further operator review',
      },
      whyThisViewExists: 'Why this view exists',
      intro: 'Documents are not passive attachments here. Each file can carry parse status, AI summary, suggested routing, and linked records across Operational Intelligence workflows.',
      badges: {
        parseStatus: 'Parse status shown inline',
        aiSummary: 'AI doc type + AI summary shown inline',
        suggestedRoute: 'Suggested route shown inline',
        linkedRecords: 'Linked records shown inline',
      },
    },
    quickCapture: {
      title: 'Quick Capture',
      description: 'Capture frontline signals in real time. AI will triage the record, route it into the correct operational flow, and trigger alerts when needed.',
      loadStatsFailed: 'Failed to load signal stats',
      requiredFields: 'Category, site, and subject are required.',
      captureFailed: 'Failed to capture signal',
      formTitle: 'Frontline Capture Form',
      formDescription: 'AI will classify the signal, draft a summary, and trigger alerts when thresholds are met.',
      openSignalIntake: 'Open Signal Intake',
      pushEnabled: 'Push Enabled',
      enablePushAlerts: 'Enable Push Alerts',
      stats: {
        total: 'Captured Signals',
        open: 'Open Signals',
        escalated: 'Escalated',
      },
      attachments: 'Attachments',
      trackedWorkspaceFiles: 'Tracked workspace files',
      storedInWorkspace: 'Stored in the shared Operational Intelligence document workspace',
      open: 'Open',
      guidance: {
        title: 'Capture guidance',
        description: 'Guidance is hidden by default. Expand only when you need quick reminders.',
      },
      sourceData: 'Registers',
      submitForAiTriage: 'Submit For AI Triage',
      latestCaptureReceipt: 'Latest Capture Receipt',
      linkedThroughEvidenceChain: 'Linked through the shared workspace evidence chain',
      viewFile: 'View File',
      noFileEvidence: 'This signal was submitted without file evidence.',
      openCreatedRecord: 'Open created record',
      emptyReceipt: 'Submit a signal once and the latest captured file evidence will stay visible here for traceability.',
      categoryMix: 'Category Mix',
      recentSignals: 'Recent Signals',
      noSignals: 'No signals captured yet.',
      pushHintEnabled: 'Push alerts are enabled on this device. High-priority signal escalations can land here immediately.',
      pushHintDisabled: 'Push alerts are not enabled on this device yet. Enable them above for live operational follow-up.',
    },
  },

  // ── Today page ──
  today: {
    title: 'Today',
    tasks: 'tasks',
    allClear: 'All clear for today!',
    allClearDesc: 'No scheduled tasks, jobs, or deliveries for today.',
    jobTitle: '{{module}} #{{id}}',
    tripTitle: 'Trip {{id}}',
    wmsTaskTitle: 'WMS {{type}} #{{id}}',
    shipmentTitle: '{{type}} {{id}}',
  },

  // ── Module labels (standalone) ──
  module: {
    hms: 'Haulage Management V1',
    tms: 'Transport Hero V1',
    wms: 'Warehouse Flow',
    fms: 'Freight Pilot',
    scm: 'Supply Chain Navigator',
    svc: 'Service',
    hrm: 'Workforce',
    oms: 'Orders',
    acc: 'Accounting',
  },

  // ── SVC (Service Management) page-level translations ──
  svc: {
    status: {
      DRAFT: 'Draft', CONFIRMED: 'Confirmed', SCHEDULED: 'Scheduled', DISPATCHED: 'Dispatched',
      IN_PROGRESS: 'In Progress', COMPLETED: 'Completed', INVOICED: 'Invoiced', CANCELLED: 'Cancelled',
      AVAILABLE: 'Available', IN_USE: 'In Use', MAINTENANCE: 'Maintenance', RETIRED: 'Retired',
      ON_DUTY: 'On Duty', OFF_DUTY: 'Off Duty', ON_LEAVE: 'On Leave', ACTIVE: 'Active', INACTIVE: 'Inactive',
    },
    serviceType: {
      crane_lift: 'Crane Lift', rigging: 'Rigging', transport: 'Transport', installation: 'Installation',
      maintenance: 'Maintenance', inspection: 'Inspection', other: 'Other',
    },
    priority: { low: 'Low', normal: 'Normal', high: 'High', urgent: 'Urgent' },
    equipmentType: {
      crane: 'Crane', forklift: 'Forklift', truck: 'Truck', generator: 'Generator',
      scaffold: 'Scaffold', tool_set: 'Tool Set', other: 'Other',
    },
    field: {
      customer: 'Customer', site: 'Site', serviceType: 'Service Type', priority: 'Priority',
      scheduledDate: 'Scheduled Date', estHours: 'Est. Hours', description: 'Description', remarks: 'Remarks',
      assetCode: 'Asset Code', name: 'Name', type: 'Type', capacity: 'Capacity', serialNo: 'Serial No.',
      location: 'Location', nextServiceDate: 'Next Service Date', code: 'Code', crewName: 'Crew Name',
      teamLeader: 'Team Leader', skills: 'Skills', siteCode: 'Site Code', siteName: 'Site Name',
      contact: 'Contact', phone: 'Phone', postalCode: 'Postal Code', address: 'Address',
    },
    kpi: { totalOrders: 'Total Orders', scheduled: 'Scheduled', inProgress: 'In Progress', completed: 'Completed' },
    tab: {
      recentOrders: 'Recent Orders', activeDispatched: 'Active / Dispatched', allOrders: 'All Orders',
      draft: 'Draft', active: 'Active', pendingDispatch: 'Pending Dispatch', dispatched: 'Dispatched',
      allEquipment: 'All Equipment', available: 'Available', maintenance: 'Maintenance',
      allCrews: 'All Crews', allSites: 'All Sites', allInvoices: 'All Invoices',
      pendingBilling: 'Pending Billing', costBreakdown: 'Cost Breakdown', summary: 'Summary',
    },
    col: {
      orderNo: 'Order No.', customer: 'Customer', site: 'Site', type: 'Type', scheduled: 'Scheduled',
      status: 'Status', crew: 'Crew', date: 'Date', equipment: 'Equipment', priority: 'Priority',
      estHrs: 'Est. Hrs', created: 'Created', assetCode: 'Asset Code', name: 'Name', capacity: 'Capacity',
      location: 'Location', nextService: 'Next Service', lastService: 'Last Service', code: 'Code',
      crewName: 'Crew Name', teamLeader: 'Team Leader', members: 'Members', skills: 'Skills',
      siteName: 'Site Name', address: 'Address', contact: 'Contact', hours: 'Hours',
      materials: 'Materials', total: 'Total', labor: 'Labor', totalCost: 'Total Cost',
      revenue: 'Revenue', marginPct: 'Margin %', period: 'Period', orders: 'Orders',
      completed: 'Completed', cost: 'Cost', avgHrsJob: 'Avg Hrs/Job', serialNo: 'Serial No.',
      phone: 'Phone', postalCode: 'Postal Code',
    },
    action: {
      confirm: 'Confirm', schedule: 'Schedule', dispatch: 'Dispatch', startWork: 'Start Work',
      complete: 'Complete', invoice: 'Invoice', cancel: 'Cancel',
      cancelConfirm: 'Cancel this service order?',
    },
    page: {
      dashboard: 'Service Management', orders: 'Service Orders', dispatch: 'Dispatch',
      equipment: 'Equipment', crew: 'Crew', sites: 'Sites', billing: 'Service Billing',
      costing: 'Service Costing', reports: 'Service Reports',
    },
    dialog: {
      newOrder: 'New Service Order', addEquipment: 'Add Equipment', addCrew: 'Add Crew', addSite: 'Add Site',
    },
  },

  // ── Common ──
  common: {
    loading: 'Loading...',
    viewAll: 'View all',
    more: 'more',
    save: 'Save',
    reset: 'Reset',
  },

  // ── Settings page ──
  settings: {
    desc: 'Personalise your Boox experience.',
    tabs: 'Tabs',
    clearTabsOnSignout: 'Clear tabs on sign out',
    clearTabsOnSignoutDesc: 'When enabled, all open tabs are closed when you sign out. Disable to keep your tabs for next session.',
    clearTabsEnabled: 'Tabs will be cleared on sign out',
    clearTabsDisabled: 'Tabs will be preserved across sessions',
    voiceCommands: 'Voice Commands',
    voiceCommandsAlwaysOn: 'Always-on PWA voice commands',
    voiceCommandsAlwaysOnDesc: 'Adds a mic toggle in the PWA sidebar and keeps listening after each command until you turn it off.',
    voiceCommandsEnabled: 'PWA voice commands enabled',
    voiceCommandsDisabled: 'PWA voice commands disabled',
    langHint: 'Applies immediately across the whole app.',
    surfaceMenu: 'Personal Surface Menu',
    surfaceMenuDesc: 'Choose which menu categories appear for you in PWA and Chrome extension.',
    surfaceSaved: 'Personal surface menu saved',
    surfaceSaveFailed: 'Failed to save personal menu',
    surfaceReset: 'Personal surface menu reset',
    surfaceResetFailed: 'Failed to reset personal menu',
    pwaMenu: 'PWA Menu',
    pwaMenuDesc: 'Current personal menu applied in go-pwa.',
    extensionMenu: 'Extension Menu',
    extensionMenuDesc: 'Current personal menu applied in Chrome extension.',
    categories: 'categories',
  },

  // ── Accent color ──
  accent: {
    label: 'Accent Color',
  },

  // ── Sidebar ──
  sidebar: {
    collapse: 'Collapse',
    expand: 'Expand',
  },

  // ── MDI Tabs ──
  mdi: {
    closeTab: 'Close Tab',
    closeOther: 'Close Others',
  },

  // ── Theme ──
  theme: {
    label: 'Theme',
    languageLabel: 'Language',
    light: 'Light',
    dark: 'Dark',
    system: 'System',
  },

  // ── Forgot Password ──
  forgotPassword: {
    title: 'Forgot Password',
    desc: 'Enter your email and we\'ll send you a reset link.',
    submit: 'Send Reset Link',
    sending: 'Sending…',
    sentTitle: 'Check Your Email',
    sentDesc: 'We\'ve sent a password reset link to {{email}}.',
    resend: 'Resend Email',
    backToLogin: 'Back to Login',
    failed: 'Failed to send reset email',
  },

  // ── Reset Password ──
  resetPassword: {
    title: 'Reset Password',
    desc: 'Enter your new password below.',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    minLength: 'Minimum 8 characters',
    mismatch: 'Passwords do not match',
    tooShort: 'Password must be at least 8 characters',
    submit: 'Reset Password',
    resetting: 'Resetting…',
    successTitle: 'Password Reset',
    successDesc: 'Your password has been reset successfully. Redirecting to login…',
    goToLogin: 'Go to Login',
    failed: 'Failed to reset password',
    invalidLink: 'Invalid Reset Link',
    invalidLinkDesc: 'This reset link is invalid or has expired.',
    requestNew: 'Request New Link',
  },

  // ── Two-Factor Authentication ──
  twoFactor: {
    title: 'Two-Factor Authentication',
    emailDesc: 'Enter the 6-digit code sent to {{email}}.',
    appDesc: 'Enter the 6-digit code from your authenticator app.',
    verify: 'Verify',
    verifying: 'Verifying…',
    invalidCode: 'Invalid verification code',
    resend: 'Resend Code',
    resendIn: 'Resend in {{seconds}}s',
    backToLogin: 'Back to Login',
  },

  // ── Admin panel ──
  admin: {
    title: 'AI Management',
    // Sidebar groups
    groupOps: 'Operations',
    groupSkills: 'Skills & Tools',
    groupTraining: 'AI Training',
    groupConfig: 'Platform Config',
    domainConfigs: 'Domain Configs',
    menuConfig: 'Menu Config',
    userRoles: 'Users & Roles',
    // Sidebar nav labels
    commandCenter: 'Command Center',
    brainMonitor: 'Brain Monitor',
    brainSoul: 'Brain Soul',
    brainSchedule: 'Brain Schedule',
    jobTimeline: 'Job Timeline',
    agentLab: 'AgentLab',
    aiTeam: 'AI Team',
    logViewer: 'Log Viewer',
    alertsApprovals: 'Alerts & Approvals',
    skillManager: 'Skill Manager',
    skillResources: 'Skill Resources',
    toolRegistry: 'Tool Registry',
    promptEditor: 'Prompt Editor',
    trainingData: 'Training Data',
    memoryManager: 'Memory Manager',
    docTemplates: 'Doc Templates',
    configVersions: 'Config Versions',
    schemaEditor: 'Schema Editor',
    workflows: 'Workflows',
    scriptEditor: 'Script Editor',
    // Common admin actions
    search: 'Search',
    refresh: 'Refresh',
    create: 'Create',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    preview: 'Preview',
    copy: 'Copy',
    all: 'All',
    required: 'Required',
    optional: 'Optional',
    noData: 'No data',
    // Prompt Editor
    prompt: {
      listTitle: 'Prompt List',
      searchPlaceholder: 'Search prompts…',
      noMatch: 'No matching prompts',
      selectHint: 'Select a prompt from the left to start editing',
      active: 'Active',
      noActiveVersion: 'No active version',
      unsavedChanges: 'Unsaved changes',
      params: 'Parameters',
      history: 'History',
      rollback: 'Rollback',
      saveNewVersion: 'Save New Version',
      targetModel: 'Target Model',
      maxTokens: 'Max Tokens',
      temperature: 'Temperature',
      variables: 'Variables (comma-separated)',
      editorPlaceholder: 'Write prompt content here…',
      changeNote: 'Change note (optional)…',
      chars: 'chars',
      tokens: 'tokens',
      versionHistory: 'Version History',
      noVersions: 'No version records',
      draft: 'Draft',
      archived: 'Archived',
      load: 'Load',
      activate: 'Activate',
      uses: '{{count}} uses',
      quality: 'Quality {{score}}%',
      emailParsingSystem: '📧 Email Parsing (System)',
      emailParsingUser: '📧 Email Parsing (User)',
      jobCreationSystem: '🚚 Job Creation (System)',
      jobCreationUser: '🚚 Job Creation (User)',
      jobValidationSystem: '✅ Job Validation (System)',
      hsCodeSystem: '📦 HS Code (System)',
      billingSystem: '💰 Billing (System)',
      customerInquirySystem: '💬 Customer Inquiry (System)',
      seaImportSystem: '🚢 Sea Import (System)',
      nvoccSystem: '📋 NVOCC Consolidation (System)',
      dgValidationSystem: '⚠️ DG Validation (System)',
      complianceSystem: '🔒 Compliance Check (System)',
      starterTemplate: 'Starter template — edit and save as v1',
      // Agent Core
      agentRouter: '🧭 Router Agent',
      agentDev: '💻 Dev Agent',
      agentOps: '⚙️ Ops Agent',
      agentData: '📊 Data Agent',
      agentCoordinator: '🔗 Coordinator Agent',
      agentSafety: '🛡️ Safety Agent',
      // Agent Domain
      agentInbox: '📬 Inbox Agent',
      agentBilling: '💳 Billing Agent',
      agentCs: '🎧 CS Agent',
      // Provider
      providerAnthropic: '🟠 Anthropic (Claude)',
      providerOpenai: '🟢 OpenAI (GPT-4)',
      providerGemini: '🔵 Google (Gemini)',
      providerDefault: '⚪ Default Provider',
      // Safety
      safetyDatabase: '🗄️ Database Safety Rules',
      safetyTenantIsolation: '🔒 Tenant Isolation Rules',
      safetySql: '🛡️ SQL Safety Rules',
      // Autonomous
      autonomousBehavior: '🤖 Autonomous Behavior',
      // Document Parsers
      docParserMbl: '📄 MBL Parser',
      docParserHbl: '📄 HBL Parser',
      docParserManifest: '📋 Manifest Parser',
      docParserNoa: '📢 NOA Parser',
    },
    // Skill Config
    skill: {
      catalog: 'Skill Resource Catalog',
      searchPlaceholder: 'Search skills…',
      noData: 'No skill data',
      selectHint: 'Select a skill to view resource config',
      resources: 'resources',
      customPoints: 'custom points',
      resourceBinding: 'Resource Bindings',
      customization: 'Customization',
      runtimePreview: 'Runtime Preview',
      declared: 'declared',
      bound: 'bound',
      isBound: 'Bound',
      notBound: 'Not Bound',
    },
    // Training Data
    training: {
      title: 'Training Data Management',
      tabExamples: 'Training Examples',
      tabEmbeddings: 'Embeddings',
      tabPreferences: 'Customer Preferences',
      searchExamples: 'Search examples…',
      newExample: 'New Example',
      total: '{{count}} total',
      golden: 'Golden',
      approved: 'Approved',
      pending: 'Pending',
      rejected: 'Rejected',
      sampleKey: 'sample-key (unique ID)',
      description: 'Description (optional)',
      inputLabel: 'Input (JSON or text)',
      outputLabel: 'Expected Output (JSON or text)',
      noExamples: 'No training examples',
      qualityLabel: 'Quality',
    },
    // Memory Manager
    memory: {
      title: 'Memory Manager',
      subtitle: '3-layer memory architecture',
      taskMemory: 'Task Memory',
      workspaceMemory: 'Workspace Memory',
      orgMemory: 'Organization Memory',
      searchPlaceholder: 'Search memory key or content…',
      records: '{{count}} records',
      noRecords: 'No memory records',
      noRecordsHint: 'Memory entries are created automatically when the Agent runs',
      expired: 'Expired',
      latest: 'Latest',
      value: 'Value',
      metadata: 'Metadata',
    },
    // Document Templates
    docTemplate: {
      title: 'Document Template Management',
      templates: '{{count}} templates',
      newTemplate: 'New Template',
      searchPlaceholder: 'Search templates…',
      invoiceTemplate: 'Invoice Template',
      quotationTemplate: 'Quotation Template',
      blTemplate: 'BL Template',
      doTemplate: 'DO Template',
      soaTemplate: 'SOA Template',
      emailTemplate: 'Email Template',
      receiptTemplate: 'Receipt Template',
      manifestTemplate: 'Manifest Template',
      newDocTemplate: 'New Document Template',
      skillId: 'Skill ID',
      resourceKey: 'Resource Key',
      type: 'Type',
      format: 'Format',
      noTemplates: 'No document templates',
      noTemplatesHint: 'Click "New Template" to add a skill document template',
    },
    // Tool Registry
    tool: {
      title: 'Tool Registry',
      toolsSkills: '{{count}} tools/skills',
      newDynamicSkill: 'New Dynamic Skill',
      searchPlaceholder: 'Search skills/tools…',
      nativeLabel: 'Native',
      dynamicLabel: 'Dynamic',
      promptDriven: 'Prompt Driven',
      toolComposed: 'Tool Composed',
      sandboxBundle: 'Sandbox Script',
      promptDrivenDesc: 'LLM generates structured output via prompt template',
      toolComposedDesc: 'Compose existing tool ID chains for execution',
      sandboxBundleDesc: 'Python/JS sandbox executes custom logic',
      slug: 'ID (slug)',
      name: 'Name',
      riskLevel: 'Risk Level',
      descriptionLabel: 'Description',
      intents: 'Intents (comma-separated)',
      promptKey: 'Prompt Key',
      toolIdChain: 'Tool ID chain (comma-separated)',
      model: 'Model',
      dynamicSkills: 'Dynamic Skills',
      nativeSkills: 'Native Skills',
      enabled: 'Enabled',
      disabled: 'Disabled',
      native: 'Native',
      dynamic: 'Dynamic',
      intentsLabel: 'Intents',
      permissions: 'Permissions',
      none: 'None',
      toolChain: 'Tool Chain',
      retry: 'Retry',
      escalation: 'Escalation',
      version: 'Version',
      noData: 'No tools/skills',
    },
    // Config Versions
    configVer: {
      title: 'Config Version Management',
      versions: '{{count}} versions',
      defaultTemplate: 'Default Template',
      editPublish: 'Edit & Publish',
      finalChannel: 'Final Channel',
      experimentalChannel: 'Experimental Channel',
      currentConfig: 'Current Active Config',
      defaultLabel: 'Default',
      cached: 'Cached',
      tenant: 'Tenant',
      layoutVersion: 'Layout Version',
      publishTime: 'Publish Time',
      signature: 'Signature',
      menuItems: 'Menu Items',
      pages: 'Pages',
      featureFlags: 'Feature Flags',
      noConfig: 'No configuration',
      publish: 'Publish',
      publishing: 'Publishing…',
      rollbackTo: 'Rollback to this version',
      versionHistory: 'Version History',
      noVersionHistory: 'No version history',
      latest: 'Latest',
      current: 'Current',
      publishNewVersion: 'Publish New Config Version',
      publishNote: 'Will auto-sign and increment version after publishing',
    },
    // User Performance / Behavior Analytics
    userPerf: {
      title: 'User Behavior Analytics',
      subtitle: 'Feature adoption · AI adoption · Risk user alerts',
      lastRefresh: 'Last refresh',
      totalUsers: 'Total Users',
      activeUsers: 'Active Users',
      activeUsersSub: 'Active in last 7 days',
      riskUsers: 'Risk Users ⚠',
      riskUsersSub: '7+ days inactive',
      avgAiAdoption: 'Avg AI Adoption',
      avgAiAdoptionSub: 'AI ops / total ops',
      totalOps: 'Total Operations',
      featureHeat: 'Feature Adoption Top 5',
      recentEvents: 'Recent Business Events',
      aiDistribution: 'AI Adoption Distribution',
      aiHigh: 'High ≥20%',
      aiMid: 'Mid 5-20%',
      aiLow: 'Low <5%',
      userTable: 'User Performance Detail',
      tableSortHint: '(click column to sort)',
      colUser: 'User',
      colTotalOps: 'Total Ops',
      colFeatures: 'Features Used',
      colActiveDays: 'Active Days',
      colAiAdoption: 'AI Adoption',
      colLastActive: 'Last Active',
      colStatus: 'Status',
      statusActive: 'Active',
      statusInactive: '⚠ 7d inactive',
      noData: 'No data',
      days: '{{count}} days',
      activeDays: '{{count}} d',
      periodPrefix: 'Past',
      justNow: 'Just now',
      minutesAgo: '{{count}}m ago',
      hoursAgo: '{{count}}h ago',
      daysAgo: '{{count}}d ago',
      last7: 'Last 7 days',
      last14: 'Last 14 days',
      last30: 'Last 30 days',
      last60: 'Last 60 days',
    },
  },

  flm: {
    page: {
      dashboard: 'Fleet Dashboard',
      assets: 'Vehicles',
      workshop: 'Work Orders',
      parts: 'Parts Inventory',
      tyres: 'Tyres',
      costing: 'Fleet Costing',
      reports: 'Fleet Reports',
    },
    desc: {
      dashboard: 'Vehicle availability, workshop load, parts alerts, tyre status and month-to-date fleet cost.',
      assets: 'Fleet asset master for lorries, vans, prime movers, trailers, chassis and support equipment.',
      workshop: 'Service requests and repair work orders with downtime and cost visibility.',
      parts: 'Workshop parts stock, reorder levels, unit costs and issue history.',
      tyres: 'Tracked tyre lifecycle from stock to fitted, repair, retread and scrap.',
      costing: 'Maintenance, tyre, fuel and fixed cost allocation by vehicle and period.',
      reports: 'Cost per km, downtime, stock movement, tyre life and compliance exception reports.',
    },
    action: { refresh: 'Refresh', create: 'Create', record: 'Record', close: 'Close', send: 'Send', notifyDriver: 'Notify Driver', resend: 'Resend Last' },
    error: { load: 'Failed to load FLM data', save: 'Failed to save FLM action' },
    loading: 'Loading FLM records...',
    empty: 'No {{label}} records yet. The FLM foundation is ready for tenant data.',
    table: {
      vehicles: 'vehicles',
      workOrders: 'work orders',
      parts: 'parts',
      tyres: 'tyres',
      costing: 'cost allocations',
    },
    col: {
      plate: 'Plate',
      type: 'Type',
      makeModel: 'Make / Model',
      status: 'Status',
      odometer: 'Odometer',
      workOrder: 'Work Order',
      vehicle: 'Vehicle',
      cost: 'Cost',
      part: 'Part',
      code: 'Code',
      stock: 'Stock',
      reorder: 'Reorder',
      unitCost: 'Unit Cost',
      serial: 'Serial',
      size: 'Size',
      position: 'Position',
      date: 'Date',
      category: 'Category',
      source: 'Source',
      amount: 'Amount',
      action: 'Action',
    },
    form: {
      assetTitle: 'Create Vehicle',
      serviceRequestTitle: 'Log Service Request',
      workOrderTitle: 'Create Work Order',
      partTitle: 'Create Part',
      stockTitle: 'Record Stock Movement',
      tyreTitle: 'Create Tyre',
      tyreEventTitle: 'Record Tyre Event',
      fuelTitle: 'Record Fuel Cost',
      complianceTitle: 'Record Compliance',
      notifyDriverTitle: 'Notify Driver',
      plateNo: 'Plate no.',
      assetName: 'Asset name',
      assetType: 'Asset type',
      odometer: 'Odometer km',
      vehicle: 'Vehicle',
      selectVehicle: 'Select vehicle',
      serviceRequest: 'Service request',
      selectServiceRequest: 'Select service request',
      requestType: 'Request type',
      workType: 'Work type',
      priority: 'Priority',
      vendorCost: 'Vendor cost',
      miscCost: 'Misc cost',
      diagnosis: 'Diagnosis / scope',
      description: 'Description',
      partCode: 'Part code',
      partName: 'Part name',
      qty: 'Quantity',
      reorder: 'Reorder level',
      unitCost: 'Unit cost',
      part: 'Part',
      selectPart: 'Select part',
      movement: 'Movement',
      workOrder: 'Work order',
      selectWorkOrder: 'Select work order',
      serialNo: 'Serial no.',
      brand: 'Brand',
      tyreSize: 'Tyre size',
      purchaseCost: 'Purchase cost',
      tyre: 'Tyre',
      selectTyre: 'Select tyre',
      eventType: 'Event type',
      position: 'Position',
      costAmount: 'Cost amount',
      litres: 'Litres',
      unitPrice: 'Unit price',
      vendor: 'Vendor',
      complianceType: 'Compliance type',
      expiryDate: 'Expiry date',
      complianceStatus: 'Compliance status',
      notificationType: 'Notification type',
      amount: 'Amount',
      note: 'Note',
    },
    success: {
      asset: 'Vehicle created',
      serviceRequest: 'Service request created',
      workOrder: 'Work order created',
      part: 'Part created',
      stock: 'Stock movement recorded',
      tyre: 'Tyre created',
      tyreEvent: 'Tyre event recorded',
      fuel: 'Fuel cost recorded',
      compliance: 'Compliance record created',
      notifyDriver: 'Driver notification sent',
      resendDriver: 'Driver notification resent',
      close: 'Work order closed',
    },
    assetType: {
      lorry: 'Lorry',
      van: 'Van',
      prime_mover: 'Prime mover',
      trailer: 'Trailer',
      forklift: 'Forklift',
      other: 'Other',
    },
    workType: {
      service: 'Service',
      repair: 'Repair',
      breakdown: 'Breakdown',
      tyre: 'Tyre',
      inspection: 'Inspection',
      other: 'Other',
    },
    requestType: {
      defect: 'Defect',
      service_due: 'Service due',
      breakdown: 'Breakdown',
      tyre: 'Tyre',
      compliance: 'Compliance',
      other: 'Other',
    },
    notificationType: {
      repair_completed: 'Repair completed',
      extra_cost_settlement: 'Extra cost settlement',
      workshop_update: 'Workshop update',
      general: 'General message',
    },
    priority: {
      low: 'Low',
      normal: 'Normal',
      high: 'High',
      urgent: 'Urgent',
    },
    movement: {
      receive: 'Receive',
      issue: 'Issue to work order',
      adjust_in: 'Adjust in',
      adjust_out: 'Adjust out',
      return: 'Return',
    },
    tyreEvent: {
      fit: 'Fit',
      remove: 'Remove',
      retread: 'Retread',
      scrap: 'Scrap',
      inspect: 'Inspect',
    },
    kpi: {
      assets: 'Fleet assets',
      available: '{{count}} available',
      blocked: 'Blocked vehicles',
      blockedHint: 'Workshop, breakdown or compliance hold',
      openWorkOrders: 'Open work orders',
      lowStockParts: '{{count}} low-stock parts',
      monthCost: 'Month cost',
      fittedTyres: '{{count}} tyres fitted',
    },
    status: {
      active: 'Active',
      workshop: 'Workshop',
      breakdown: 'Breakdown',
      compliance_hold: 'Compliance hold',
      off_road: 'Off road',
      sold: 'Sold',
      draft: 'Draft',
      open: 'Open',
      in_progress: 'In progress',
      waiting_parts: 'Waiting parts',
      vendor_work: 'Vendor work',
      completed: 'Completed',
      closed: 'Closed',
      cancelled: 'Cancelled',
      in_stock: 'In stock',
      fitted: 'Fitted',
      repair: 'Repair',
      retread: 'Retread',
      scrapped: 'Scrapped',
      expiring: 'Expiring',
      hold: 'Hold',
      expired: 'Expired',
      waived: 'Waived',
      triaged: 'Triaged',
      approved: 'Approved',
      waiting_driver: 'Waiting driver',
    },
    panel: {
      recentRequests: 'Recent service requests',
      complianceAlerts: 'Compliance watchlist',
      driverNotifications: 'Driver WhatsApp log',
    },
    next: {
      title: 'Next implementation slices',
      workshopTitle: 'Work Orders MVP',
      workshopText: 'Create, cost and close service repair work orders.',
      inventoryTitle: 'Parts and tyres',
      inventoryText: 'Issue parts and track tyre fitment, rotation, repair and scrap.',
      dispatchTitle: 'Dispatch signal',
      dispatchText: 'Block unavailable fleet assets from TMS/HMS/SVC assignment.',
    },
  },

  // ─── Tenant Admin ─────────────────────────────
  tenantAdmin: {
    title: 'Tenant Management',
    subtitle: 'Manage tenant modules, plans & access',
    back: 'Back',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    refresh: 'Refresh',
    core: 'Core',
    saveChanges: 'Save Changes',
    authControl: 'Auth Control',
    connectorSetup: 'Connector Setup',
    skillPolicies: 'Skill Policies',
    manageConnectors: 'Manage Connectors',
    managePolicies: 'Manage Policies',
    tenantInfo: 'Tenant Information',
    operationalModules: 'Operational Modules',
    modulesDesc: 'Control explicit SDK modules for this tenant. Nothing is auto-selected; legacy module codes are not written from this screen.',
    tenantMembers: 'Tenant Members',
    loading: 'Loading…',
    loadingTenants: 'Loading tenants…',
    loadingConnectors: 'Loading connectors…',
    noMembers: 'No members',
    noConnectors: 'No connectors configured yet. This section shows the tenant integration points.',
    noTenantsMatch: 'No tenants match the filter',
    searchPlaceholder: 'Search by name or slug…',
    allTenants: 'All Tenants',
    logisticsTenants: 'Logistics Tenants (No FMS)',
    freightTenants: 'Freight Tenants (With FM)',
    fields: {
      name: 'Name',
      slug: 'Slug',
      plan: 'Plan',
      status: 'Status',
      currency: 'Currency',
      locale: 'Locale',
      timezone: 'Timezone',
      country: 'Country',
      taxId: 'Tax ID',
      companyRegNo: 'Company Reg No',
      businessDesc: 'Business Description',
    },
    placeholders: {
      taxId: 'e.g. GST Reg No',
      companyRegNo: 'e.g. UEN 201234567M',
      businessDesc: 'Brief description of the company\'s business…',
    },
    moduleCategory: {
      business: 'Business Management',
      vertical: 'Vertical Modules',
      integration: 'Integration & Connectors',
    },
    modules: {
      OMS: 'Orders (OMS)',
      CRM: 'Business Management',
      INBOX: 'Inbox (INBOX)',
      AIC: 'AI Chat (AIC)',
      OPI: 'Operational Intelligence (OPI)',
      AI: 'AI Agentic Control (AI)',
      TA: 'Task Management (TA)',
      RM: 'Business Management (BM)',
      TM: 'Transport Hero (TM)',
      TP: 'Transport Planning (TP)',
      CT: 'Container Trucking (CT)',
      WM: 'Warehouse Management (WM)',
      CF: 'CFS Warehouse (CF)',
      FM: 'Freight Management (FM)',
      SC: 'Supply Chain (SC)',
      MT: 'Maritime & Port Agency (MT)',
      TMS: 'Transport Hero V1 (TMS)',
      HMS: 'Container Trucking (HMS)',
      FLM: 'Fleet Management (FLM)',
      DMS: 'Depot (DMS)',
      FMS: 'Freight (FMS)',
      SAS: 'Maritime Desk (SAS)',
      WMS: 'Warehouse (WMS)',
      HRM: 'Workforce (HRM)',
      ACC: 'Accounting (ACC)',
      SET: 'Settings (SET)',
      SOC: 'Shipper-Owned Container (SOC)',
      SCM: 'Supply Chain (SCM)',
      SVC: 'Service Management (SVC)',
      CW: 'CargoWise Connector',
      CERP: 'CargoERP Connector',
      EZSH: 'EZShip Connector',
      SFRT: 'SysFreight Connector',
      PRO2: 'PRO2 Connector',
      KDCFS: 'KDCFS Connector',
      QB: 'QuickBooks Connector',
      XERO: 'Xero Connector',
      ORCL: 'Oracle ERP Connector',
      SAP: 'SAP Connector',
      NETSUITE: 'NetSuite Connector',
      FR8: 'FR8LAN Connector',
      FLINK: 'FreightLink Connector',
      KFLD: 'Keyfield Connector',
      OPTTRK: 'Opt-E-Truck Connector',
      OPTHUB: 'Opt-E-Hub Connector',
    },
    moduleDesc: {
      OMS: 'Core business: orders, quotations, pipelines, customers',
      CRM: 'Business management: pipeline, contacts, account 360, recovery, quotations, and self-service signals',
      INBOX: 'Messages, email, WhatsApp, tasks, approvals',
      AIC: 'AI copilot chat, side panel, and agent conversation workspace',
      OPI: 'AI operational intelligence workspace: performance analysis, incidents, service signals, inventory anomalies, EHS, and management brief',
      AI: 'SDK-governed agentic control: AI workbench, prompt profiles, approvals, context and audit',
      TA: 'SDK menu-set for tasks, actions, schedules, attachments, assignment and reports',
      RM: 'Business Management: customer, supplier, contact, partner, quotation, and service relationship layer',
      TM: 'New dynamic transport profile: inbox, job orders, trips, billing, planner, PWA tasks, share, and reports',
      TP: 'AI Agentic native transport planning: planner, constraints, costing, documents and approval-gated AI proposals',
      CT: 'New dynamic container trucking profile: job orders, containers, trips, driver teams, PWA tasks, share, billing, and reports',
      WM: 'New dynamic warehouse profile: receiving, inventory, picking, putaway, hourly resource planning, PWA tasks, share, and reports',
      CF: 'New dynamic CFS warehouse profile: containers, cargo tally, devanning, stuffing, storage, release, FM handoff, PWA tasks, share, and billing',
      FM: 'New dynamic freight profile: shipments, documents, pricing, costing, billing handoff, share, and reports',
      SC: 'Supply chain profile: order, supplier, procurement, fulfillment, inventory and document control',
      MT: 'Maritime and port agency profile: vessel, port call, berth, tally, documents, service orders and disbursement',
      TMS: 'Local delivery, trucking, planner, dispatch',
      HMS: 'FCL container haulage, port ops, IMP/RET, COL/EXP',
      FLM: 'Vehicles, workshop repairs, parts, tyres, compliance and fleet costing',
      DMS: 'Depot operations, gate, yard, M&R',
      FMS: 'Sea/air import/export, CFS, customs, rates',
      SAS: 'Shipping and port agency, vessel and port operations, port call documents, and principal coordination',
      WMS: 'Receiving, inventory, outbound, work orders',
      HRM: 'Employees, attendance, payroll, leave, HR self-service',
      ACC: 'AR/AP, journal entries, tax codes, financial reports',
      SET: 'Company settings, team, billing, templates',
      SOC: 'Shipper-owned container control — always enabled',
      SCM: 'Sales orders, purchase orders, inventory, product catalog, fulfillment',
      SVC: 'Service orders, equipment/asset management, crew scheduling, site-based work',
      CW: 'WiseTech CargoWise One / ediEnterprise integration',
      CERP: 'CargoERP legacy system data bridge',
      EZSH: 'EZShip shipping platform data bridge',
      SFRT: 'SysFreight ERP data bridge',
      PRO2: 'PRO2 CargoConnect system data bridge',
      KDCFS: 'KDCFS CFS system data bridge',
      QB: 'Intuit QuickBooks accounting sync',
      XERO: 'Xero cloud accounting sync',
      ORCL: 'Oracle ERP / NetSuite integration',
      SAP: 'SAP S/4HANA / Business One integration',
      NETSUITE: 'Oracle NetSuite ERP integration',
      FR8: 'FR8LAN freight marketplace connector',
      FLINK: 'FreightLink booking & tracking connector',
      KFLD: 'Keyfield Logistics system connector',
      OPTTRK: 'Opt-E-Truck fleet management connector',
      OPTHUB: 'Opt-E-Hub warehouse management connector',
    },
    stats: {
      totalJobs: 'Total Jobs',
      members: 'Members',
      lastActive: 'Last Active',
      connectors: 'Connectors',
    },
    summary: {
      totalTenants: 'Total Tenants',
      active: 'Active',
      freight: 'Freight (FM)',
      totalJobs: 'Total Jobs',
    },
    filter: {
      all: 'All',
      logistics: 'Logistics',
      freight: 'Freight',
    },
    listCols: {
      tenant: 'Tenant',
      status: 'Status',
      plan: 'Plan',
      modules: 'Modules',
      jobs: 'Jobs',
      lastActivity: 'Last Activity',
    },
    connectorCols: {
      connector: 'Connector',
      type: 'Type',
      endpoint: 'Endpoint',
      policy: 'Policy',
      mode: 'Mode',
      status: 'Status',
    },
    memberCols: {
      name: 'Name',
      email: 'Email',
      role: 'Role',
      joined: 'Joined',
      actions: 'Actions',
    },
    toast: {
      modulesSaved: 'Modules saved',
      modulesSaveFailed: 'Failed to save modules',
      tenantInfoSaved: 'Tenant info saved',
      tenantInfoSaveFailed: 'Failed to save tenant info',
      memberUpdated: 'Member updated',
      memberUpdateFailed: 'Failed to update member',
      switchedTenant: 'Switched tenant context to {{name}}',
      switchFailed: 'Failed to switch tenant context',
      loadMembersFailed: 'Failed to load members',
    },
  },
  chat: {
    searchPlaceholder: 'Search...',
    newChat: 'New conversation',
    noSessions: 'No conversations yet.\nClick + to start.',
    noSearchResults: 'No matching conversations',
    archive: 'Archive',
    delete: 'Delete',
    archivedCount: 'Archived ({{count}})',
    restore: 'Restore',
    managePrompts: 'Manage Quick Prompts',
    promptLabel: 'Short name (e.g. 📋 Today summary)',
    promptContent: 'Full question to ask AI...',
    autoExecute: 'Send immediately on click',
    noPrompts: 'No quick prompts. Click "Add" to create one.',
    confirmDelete: 'Are you sure you want to delete "{{label}}"?',
    deleteFailed: 'Failed to delete conversation',
    archived: 'Conversation archived',
    restored: 'Conversation restored',
    chatTitle: 'Chat',
    thinking: 'Thinking…',
    share: 'Share conversation',
    typeToStart: 'Type below to start a conversation',
    startTyping: 'Say something to start…',
    quickPrompts: 'Quick Prompts',
    inputPlaceholder: 'Ask anything… (Enter to send, Shift+Enter for newline)',
    stopRecording: 'Tap to stop',
    voiceInput: 'Tap to speak',
    stop: 'Stop generating',
    disclaimer: 'AI responses may not be accurate. Always verify critical information.',
    shareTitle: 'Share Conversation',
    selectMessages: 'Include messages',
    shareExpiry: 'Link expires after',
    generateLink: 'Generate Share Link',
    copied: 'Copied!',
    copy: 'Copy',
    sharedConversation: 'Shared conversation',
    shareWhatsApp: 'Share via WhatsApp',
    shareInfo: 'Anyone with this link can view this conversation without logging in.',
    expiresAt: 'Expires',
  },

  // ── Finance module ──
  finance: {
    // Settlement shared
    method: {
      bank_transfer: 'Bank Transfer',
      cheque: 'Cheque',
      cash: 'Cash',
      paynow: 'PayNow',
      fps: 'FPS',
      other: 'Other',
    },
    col: {
      document: 'Document',
      method: 'Method',
      date: 'Date',
      amount: 'Amount',
      unallocated: 'Unallocated',
      allocated: 'Allocated',
      status: 'Status',
    },
    kpi: {
      documents: 'Documents',
      unallocatedExposure: 'Unallocated Exposure',
    },
    controls: {
      title: 'Settlement controls',
      committedCash: 'Committed cash movement',
      allocationOpen: 'Allocation still open',
      unallocatedAmount: 'Unallocated amount',
      requiresApproval: 'Requires approval',
      none: 'None',
      yes: 'Yes',
      no: 'No',
    },
    action: {
      assist: 'Assist',
      refresh: 'Refresh',
      void: 'Void',
      reverse: 'Reverse',
      apply: 'Apply',
    },
    dock: {
      header: '{{title}} Header',
      appliedAllocations: 'Applied allocations',
      noAllocations: 'No allocations applied yet.',
      lineBreakdown: 'Payment line breakdown',
      noLines: 'No line breakdown captured.',
      outstandingDocs: 'Outstanding counterpart documents',
      noOutstanding: 'No outstanding {{type}} documents found for this party.',
      outstandingAmt: 'Outstanding',
      noDueDate: 'No due date',
    },
    toast: {
      allocationApplied: 'Allocation applied',
      allocationReversed: 'Allocation reversed',
      noUnallocated: 'No unallocated amount left to apply',
      loadFailed: 'Failed to load {{entity}}',
      allocationFailed: 'Failed to apply allocation',
      reverseFailed: 'Failed to reverse allocation',
      voidConfirm: 'Void this {{kind}}? Existing allocations will be reversed.',
      voided: '{{title}} voided',
      voidFailed: 'Failed to void {{entity}}',
    },
    empty: {
      selectRecord: 'Select a record to inspect allocation readiness and outstanding counterpart documents.',
    },
  },
  commonAction: {
    refresh: 'Refresh',
    runNow: 'Run Now',
    newTask: 'New Task',
    newLocalService: 'New Local Service',
    create: 'Create',
    save: 'Save',
  },

  hmsMatchbox: {
    title: 'MatchBox Re-use Leads',
    subtitle: 'WhatsApp group discovery feed for HMS container re-use. Controllers can review evidence, qualify supply or demand, and prepare MatchBox API submission after checklist approval.',
    searchPlaceholder: 'Search line, size, sender, location, message...',
    shown: '{{count}} shown',
    loadingLeads: 'Loading MatchBox re-use leads...',
    pendingExtraction: 'Pending extraction',
    whatsappGroup: 'WhatsApp group',
    view: 'View',
    empty: {
      title: 'No re-use leads found',
      description: 'The read-only WhatsApp monitor will populate this board once the group connector ingests messages with container, line, location, or timing signals.',
    },
    badge: {
      readOnlyMonitor: 'Read-only monitor',
      readOnlySource: 'Read-only source',
      sendDisabled: 'Send disabled',
    },
    stats: {
      totalLeads: 'Total leads',
      needReview: 'Need review',
    },
    status: {
      all: 'All status',
      new: 'New',
      needsReview: 'Needs review',
      matched: 'Matched',
      converted: 'Converted',
      discarded: 'Discarded',
    },
    intent: {
      all: 'All intent',
      supply: 'Supply',
      demand: 'Demand',
      question: 'Question',
      reply: 'Reply',
      unknown: 'Unknown',
    },
    fields: {
      status: 'Status',
      intent: 'Intent',
      opportunity: 'Opportunity',
      source: 'Source',
      sender: 'Sender',
      timing: 'Timing',
      confidence: 'Confidence',
      group: 'Group',
      messageId: 'Message ID',
      messageTime: 'Message time',
      shippingLine: 'Shipping line',
      containerType: 'Container type',
      containerNumber: 'Container number',
      bookingNumber: 'Booking number',
      location: 'Location',
      personInCharge: 'Person in charge',
      remark: 'Remark',
    },
    checklistStatus: {
      not_required: 'not required',
      pending: 'pending',
      ready: 'ready',
      warning: 'warning',
      blocked: 'blocked',
      approved: 'approved',
      rejected: 'rejected',
    },
    approvalStatus: {
      not_requested: 'not requested',
      pending: 'pending',
      approved: 'approved',
      rejected: 'rejected',
    },
    checklist: {
      loading: 'Loading checklist...',
      convertFirst: 'Convert this lead to a candidate first. The system will create the readiness checklist with timing, person in charge, remarks, and attachment support.',
      reuseGate: 'Reuse gate',
      reuseGateHint: 'All hard blockers must be ready before MatchBox CreateReuse should run.',
      canCreateReuse: 'Can create reuse',
      notReady: 'Not ready',
      runDryRun: 'Run dry-run',
      createReuseDryRun: 'CreateReuse dry-run',
      activityDryRun: 'Activity dry-run',
      billingDryRun: 'Billing dry-run',
      billingRulePlaceholder: 'Billing rule set, e.g. hms-matchbox-reuse-sg-v1',
      eligibility: 'Eligibility',
      readyToCallMatchbox: 'ready to call MatchBox',
      missingFields: 'missing fields',
      gateClear: 'gate clear',
      blocked: 'blocked',
      activitySync: 'Activity sync',
      activityRecords: '{{count}} activity record(s)',
      billingDraft: 'Billing draft',
      lines: '{{count}} line(s)',
      reuseCreated: 'MatchBox reuse created:',
      requiredBefore: 'Required before',
      source: 'Source',
      attachmentRefs: '{{count}} attachment reference(s)',
      addRef: 'Add ref',
      attachment: 'Attachment',
      attachmentPlaceholder: 'Paste document link, photo ref, or file name',
      attach: 'Attach',
    },
    detail: {
      title: 'Re-use Lead Evidence',
      originalMessage: 'Original WhatsApp message',
      aiConfidence: 'AI extraction confidence',
      confidenceHint: 'Below 65% should remain in Needs review until a controller checks the message and supporting evidence.',
      nextWorkflow: 'Next workflow',
      nextWorkflowHint: 'Controller verifies checklist, then converts the lead into a MatchBox candidate.',
      candidateCreated: 'Candidate created',
      convertToCandidate: 'Convert to candidate',
      readinessChecklist: 'Readiness checklist',
      readinessChecklistHint: 'Checklist items include timing, person in charge, remarks, and attachment references.',
    },
    errors: {
      loadLeads: 'Failed to load MatchBox re-use leads',
      loadChecklist: 'Failed to load candidate checklist',
      convertLead: 'Failed to convert lead to candidate',
      updateChecklist: 'Failed to update checklist item',
      attachEvidence: 'Failed to attach evidence reference',
      updateReadiness: 'Failed to update candidate readiness',
      runEligibility: 'Failed to run eligibility dry-run',
      runCreateReuse: 'Failed to run CreateReuse dry-run',
      runActivitySync: 'Failed to run activity sync dry-run',
      runBillingDraft: 'Failed to run billing draft dry-run',
    },
  },
  hmsPricing: {
    title: 'HMS Pricing',
    subtitle: 'Quotation & Rates, Billing Rules, and Costing Methods',
    tabs: {
      rates: 'Quotation / Rates',
      billing: 'Billing',
      costing: 'Costing',
    },
  },
  hmsRates: {
    title: 'Rates / Quotation',
    description: 'This area only contains standard rates, customer-specific rates, quotations, and rate cards. It is not costing or billing.',
    searchPlaceholder: 'Quote no, customer, route…',
    rateCount: '{{count}} rates',
    empty: 'No rates found',
    kpi: {
      totalRates: 'Total Rates',
      active: 'Active',
      expiring: 'Expiring (30d)',
      drafts: 'Drafts',
    },
    status: {
      all: 'All Status',
      draft: 'draft',
      sent: 'sent',
      accepted: 'accepted',
      rejected: 'rejected',
      expired: 'expired',
    },
    fields: {
      quoteNo: 'Quote No.',
      customer: 'Customer',
      route: 'Route',
      container: 'Container',
      baseRate: 'Base Rate',
      surcharges: 'Surcharges',
      total: 'Total',
      status: 'Status',
      validFrom: 'Valid From',
      validTo: 'Valid To',
      actions: 'Actions',
    },
    actions: {
      newRate: 'New Rate',
    },
  },
  shippingAgency: {
    accounts: {
      pageTitle: 'Shipping Agency Accounts',
      activeAccounts: 'Active Accounts',
      creditHold: 'Credit Hold',
      chargeProfiles: 'Charge Profiles',
    },
    principalTasks: {
      queueTitle: 'Principal Task Desk',
      queued: 'Queued',
      running: 'Running',
      needsOverride: 'Needs Override',
      empty: 'No principal integration task yet.',
      runReady: 'Authenticated browser plan is ready',
    },
    localServices: {
      pageTitle: 'Local Services Desk',
      truckingOrders: 'Trucking Orders',
      depotOrders: 'Depot Orders',
      backlog: 'Open Service Backlog',
      revenuePlanned: 'Revenue Planned',
      marginPlanned: 'Margin Planned',
      empty: 'No local service orders yet.',
      filtered: 'Filtered by booking {{bookingNo}}',
      createTitle: 'Create Local Service Order',
      loadingQueue: 'Loading local service coordination queue…',
      vendor: 'Vendor',
      container: 'Container',
      scheduled: 'Scheduled',
      revenue: 'Revenue',
      cost: 'Cost',
      margin: 'Margin',
      customerBilling: 'Customer Billing',
      vendorCost: 'Vendor Cost',
      openArDraft: 'Open AR Draft',
      openApDraft: 'Open AP Draft',
      openServiceDesk: 'Open service order desk',
      openDepotMoves: 'Open depot moves',
      generateArDraft: 'Generate AR Draft',
      generateApDraft: 'Generate AP Draft',
      arDraftReady: 'AR Draft Ready',
      apDraftReady: 'AP Draft Ready',
      postCustomerInvoice: 'Post Customer Invoice',
      postVendorBill: 'Post Vendor Bill',
      confirmReceipt: 'Confirm Receipt',
      confirmVendorPayment: 'Confirm Vendor Payment',
      customerInvoicePosted: 'Customer invoice posted',
      vendorBillPosted: 'Vendor bill posted',
      customerReceiptConfirmed: 'Customer receipt confirmed',
      vendorPaymentConfirmed: 'Vendor payment confirmed',
      settlementActionFailed: 'Failed to complete settlement action',
      notStarted: 'Not Started',
      draftReady: 'Draft Ready',
      posted: 'Posted',
      partiallySettled: 'Partially Settled',
      settled: 'Settled',
      voided: 'Voided',
      pending: 'Pending',
    },
    emailIntake: {
      pageTitle: 'AI Email Intake',
      subtitle: 'Turn inbound agency email into booking, documentation, release, local service, or Evergreen task drafts.',
      from: 'From',
      to: 'To',
      subject: 'Subject',
      body: 'Email Body',
      autoCreate: 'Auto-create draft work item',
      submit: 'Process Email',
      result: 'Intake Result',
      draftKind: 'Draft Kind',
      linkedBooking: 'Linked Booking',
    },
  },
  depotModule: {
    dashboardTitle: 'Depot Operations Overview',
    dashboardSubtitle: 'Gate, yard, EIR, inspection, moves, and billing in one place.',
  },
  socModule: {
    dashboardTitle: 'SOC Equipment Control Tower',
    dashboardSubtitle: 'Watch pool availability, release execution, overdue returns, and charge exposure.',
  },
} as const;

export default en;
export type TranslationKeys = typeof en;
